import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import FromFieldText from '../../../atoms/FromFieldText';
import './SingleAsset.css';
import './UploadInvoice.css';
import {
    getAllAssetsTagDataNotConsumable, getAssetsInvoiceCount, getInvoices,
    getSTPI, getSuppliers, saveSingleInvoice,
} from '../../../services/asset.service';
import * as CryptoJS from "crypto-js";

const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;

export default function UploadAssetInvoice() {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const elementRef = useRef();

    useEffect(() => {
        if (Tag !== '' && Tag !== null) {
            getTagAasetInfo(Tag);
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
        getAllAssetsTagDataNotConsumable(oData).then(res => {
            if (res?.data?.data?.length) setAllAssetsData(res.data.data);
        });

        getSuppliers(oData).then(res => {
            if (res?.data?.data?.length) setSuppliersData(res.data.data);
        });

    }, []);

    const getTagAasetInfo = function (Tag) {
        try {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'tag': Tag },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = { 'token': EncryptData }
            getSTPI(oData1).then(function (res) {
                if (res?.data?.data) {
                    var stpiInfo = res.data.data.assetInfo;
                    setTag(stpiInfo.tag);
                }
            });
        } catch (err) {
            // Handle error
        }
    }

    const errRef = useRef();
    const [imgDesc, setImgDesc] = useState('');
    const [ErrImgDesc, setErrImgDesc] = useState(false);
    const [uploadassetinvoice, setUploadAssetInvoice] = useState([]);
    const [ErrUploadAssetInvoice, setErrUploadAssetInvoice] = useState(false);

    const [tag, setTag] = useState('');
    const [supplier, setSupplier] = useState('');
    const [invoice, setInvoice] = useState('');

    const [ErrTag, setErrTag] = useState(false);
    const [ErrInvoice, setErrInvoice] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [validName, setValidName] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [assetInfo, setAssetInfo] = useState({});
    const [allAssets, setAllAssetsData] = useState([]);
    const [suppliers, setSuppliersData] = useState([]);
    const [invoices, setInvoicesData] = useState([]);
    const [supplierReadonly, setSupplierReadonly] = useState(false);
    const [tagReadonly, setTagReadonly] = useState('');
    const [NoOfDoc, setNoOfDoc] = useState('');
    const [ErrNoOfDoc, setErrNoOfDoc] = useState(false);
    const [imageCount, setImageCount] = useState(0);
    const [DocTypeList, setDocTypeList] = useState([]);

    const maxFiles = 5 - imageCount;

    const handleUploadInvoice = (e) => {
        const files = e.target.files;
        let totalSize = 0;
        const maxFileSize = 5 * 1024 * 1024;

        if (files.length > maxFiles) {
            setErrUploadAssetInvoice(`You can only upload a maximum of ${maxFiles} files.`);
            return;
        }

        const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
        const allowedExts = ['pdf', 'png', 'jpg', 'jpeg'];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const ext = file.name.split('.').pop().toLowerCase();
            if (!allowedTypes.includes(file.type) && !allowedExts.includes(ext)) {
                setErrUploadAssetInvoice(`File '${file.name}' is not a valid format. Only PDF, PNG, JPG, JPEG files are allowed.`);
                return;
            }
            totalSize += file.size;
            if (totalSize > maxFileSize) {
                setErrUploadAssetInvoice(`File '${file.name}' exceeds the maximum file size limit of 5MB.`);
                return;
            }
        }

        setErrUploadAssetInvoice('');
        setUploadAssetInvoice(files);
    };

    const remainingFiles = maxFiles - uploadassetinvoice.length;

    const optionList = [];
    allAssets && allAssets.length > 0 ? (
        allAssets.map((option) => (
            optionList.push({ value: option.tag, label: option.tag })
        ))
    ) : (
        optionList.push({ value: "", label: "No Data" })
    )

    const [selectedOptions, setSelectedOptions] = useState();

    function handleSelect(data) {
        setSelectedOptions(data);
        setSupplierReadonly(true);
        setTag(data.value);
        fetchImageCount(data.value);
    }

    const fetchImageCount = (selectedTag) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': selectedTag, 'invoice_no': invoice, 'supplier_name': supplier },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = { 'token': EncryptData }
        getAssetsInvoiceCount(oData3).then(res => {
            const imageCount = res.data.data[0]?.count;
            const docTypeList = res.data?.doc_type || [];
            setImageCount(imageCount);
            setDocTypeList(docTypeList);
        }).catch(error => {
            console.error('Error fetching image count:', error);
        });
    };

    const fetchInvoiceCount = (invoice_no) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': tag, 'invoice_no': invoice, 'supplier_name': supplier },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = { 'token': EncryptData }
        getAssetsInvoiceCount(oData3).then(res => {
            const imageCount = res.data.data[0]?.count;
            const docTypeList = res.data?.doc_type || [];
            setImageCount(imageCount);
            setDocTypeList(docTypeList);
        }).catch(error => {
            console.error('Error fetching image count:', error);
        });
    };

    const supplierList = [];
    suppliers && suppliers.length > 0 ? (
        suppliers.map((option) => (
            supplierList.push({ value: option.supplier_name, label: option.supplier_name })
        ))
    ) : (
        supplierList.push({ value: "", label: "No Data" })
    )

    const [supplierOptions, setSupplierOptions] = useState();

    function handleSupplier(data) {
        setSupplierOptions(data);
        setSupplier(data.value);
        var oParam1 = { 'supplier_name': data.value }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': oParam1,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData2 = { 'token': EncryptData }
        getInvoices(oData2).then(res => {
            if (res?.data?.data?.length) setInvoicesData(res.data.data);
        });
        setTagReadonly('readonly');
        setTag('');
    }

    const invoiceList = [];
    invoices && invoices.length > 0 ? (
        invoices.map((option) => (
            invoiceList.push({ value: option.invoice_no, label: option.invoice_no })
        ))
    ) : (
        invoiceList.push({ value: "", label: "No Data" })
    )

    const [invoiceOptions, setInvoiceOptions] = useState();

    function handleInvoice(data) {
        setInvoiceOptions(data);
        setInvoice(data.value);
        setNoOfDoc('');
        fetchInvoiceCount(data.value);
    }

    const handleNoDoc = (e) => {
        let value = e.target.value;
        setNoOfDoc(value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;

        if (tag == "" && invoice == '') {
            setErrInvoice('Tag OR Invoice is required');
            valid_Name = false;
        } else {
            setErrInvoice('');
        }

        if (!TEXT_REGEX.test(imgDesc)) {
            setErrImgDesc('Invoice description is required');
            valid_Name = false;
        } else {
            setErrImgDesc('');
        }

        if (!TEXT_REGEX.test(NoOfDoc)) {
            setErrNoOfDoc('Invoice document number is required');
            valid_Name = false;
        } else {
            setErrNoOfDoc('');
        }

        if (uploadassetinvoice == '') {
            setErrUploadAssetInvoice('Upload asset invoices is required');
            valid_Name = false;
        } else {
            setErrUploadAssetInvoice('');
        }

        if (valid_Name) {
            saveData();
        } else {
            return false;
        }
    }

    const resetAssetInfo = function () {
        setTag('');
        setImgDesc('');
        setSupplier('');
        setInvoice('');
        setNoOfDoc('');
        setSupplierOptions('');
        setUploadAssetInvoice([]);
        setInvoicesData('');
        setSelectedOptions(null);
        setInvoiceOptions(null);
    }

    const getTagInfo = function () {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = { 'token': EncryptData }
        getSTPI(oData3).then(function (res) {
            var aInfo = {};
            if (res?.data?.data?.assetInfo) {
                setErrMsg('');
                aInfo = res.data.data.assetInfo;
                setAssetInfo(aInfo);
                setTag(aInfo.tag);
            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }
        });
    }

    const saveData = function () {
        try {
            const formData = new FormData();
            let jsonData = {
                'tag': tag,
                'invoice_no': invoice,
                'supplier_name': supplier,
                'asset_invoice_desc': imgDesc,
                'upload_dir': invoice,
                'doc_type': NoOfDoc,
                'application_type': 'Web',
                'created_by': sessionStorage.getItem('LoggedInUserId'),
                'companyshortname': sessionStorage.getItem("LoggedInCompanyShortName"),
                'users': {
                    'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                    'department_id': sessionStorage.getItem('LoggedInDepartmentId'),
                    'division_id': sessionStorage.getItem('LoggedInDivisionId'),
                }
            }

            for (let i = 0; i < uploadassetinvoice.length; i++) {
                const file = uploadassetinvoice[i];
                formData.append("invoices[]", file);
            }

            var objAudit = {
                'audit_module': 'Upload Invoices',
                'audit_method': 'created',
                'audit_tag': tag,
                'old_values': '',
                'new_values': JSON.stringify(jsonData)
            }
            jsonData.audit_params = objAudit;

            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(jsonData), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            formData.append("metadata", encryptedData);

            saveSingleInvoice(formData).then(function (res) {
                if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    setDisabled(true);
                    setErrMsg(false);
                    setErrTag('');
                    resetAssetInfo();
                }
            }).catch((error) => {
                setErrMsg('No result');
            })
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('Username Taken');
            } else {
                setErrMsg('Insert/Update Failed');
            }
        }
    }

    // Custom styles for react-select
    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '42px',
            borderColor: '#e2e6ef',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#0e8aca'
            }
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#0e8aca' : state.isFocused ? '#eef7fd' : 'white',
            color: state.isSelected ? 'white' : '#333',
            cursor: 'pointer'
        })
    };

    return (
        <div className="al-page">
            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-cloud-upload-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Upload Asset Invoices</h5>
                        <p className="al-page-subtitle">Upload and manage invoice documents for assets</p>
                    </div>
                </div>
            </div>

            {/* ══ ALERTS ══ */}
            {success && (
                <div className="upload-invoice-alert upload-invoice-alert-success">
                    <i className="bi bi-check-circle-fill"></i>
                    <span>{success}</span>
                </div>
            )}
            {errMsg && (
                <div className="upload-invoice-alert upload-invoice-alert-danger">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                    <span>{errMsg}</span>
                </div>
            )}

            {/* ══ SEARCH SECTION ══ */}
            {!(Tag !== '' && Tag !== null) && (
                <div className="upload-invoice-card" id="search-section">


                    {/* Search by TAG */}
                    <div className="upload-invoice-search-row">
                        <div className="upload-invoice-search-label">
                            <i className="bi bi-tag-fill" />
                            <label>Search by TAG</label>
                        </div>
                        <div className="upload-invoice-search-grid">
                            <div className="upload-invoice-select-container">
                                <Select
                                    options={optionList}
                                    placeholder="Select asset TAG..."
                                    value={selectedOptions}
                                    onChange={handleSelect}
                                    isDisabled={supplierReadonly}
                                    styles={selectStyles}
                                />
                                {ErrTag && (
                                    <span className="upload-invoice-error-message">
                                        <i className="bi bi-exclamation-circle" /> {ErrTag}
                                    </span>
                                )}
                            </div>

                            <div className="al-search-actions">
                                <button onClick={getTagInfo} className="al-btn al-btn-primary">
                                    <i className="bi bi-search" /> Search
                                </button>
                                <a href="/upload-invoice">
                                    <button className="al-btn al-btn-outline">
                                        <i className="bi bi-arrow-clockwise" /> Reset
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* OR Divider */}
                    <div className="upload-invoice-divider">
                        <span>OR</span>
                    </div>

                    {/* Search by Supplier & Invoice */}
                    <div className="upload-invoice-form-grid upload-invoice-form-grid-2col">
                        <div className="upload-invoice-form-group">
                            <div className="upload-invoice-search-label">
                                <i className="bi bi-building" />
                                <label>Search by Supplier</label>
                            </div>
                            <div className="upload-invoice-select-container">
                                <Select
                                    options={supplierList}
                                    placeholder="Select supplier..."
                                    value={supplierOptions}
                                    onChange={handleSupplier}
                                    isDisabled={tagReadonly}
                                    styles={selectStyles}
                                />
                            </div>
                        </div>

                        <div className="upload-invoice-form-group">
                            <div className="upload-invoice-search-label">
                                <i className="bi bi-receipt" />
                                <label>Search by Invoice No.</label>
                            </div>
                            <div className="upload-invoice-select-container">
                                <Select
                                    options={invoiceList}
                                    placeholder="Select invoice..."
                                    value={invoiceOptions}
                                    onChange={handleInvoice}
                                    styles={selectStyles}
                                />
                                {ErrInvoice && (
                                    <span className="upload-invoice-error-message">
                                        <i className="bi bi-exclamation-circle" /> {ErrInvoice}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ══ INVOICE DETAILS FORM ══ */}
            <div className="upload-invoice-card" id="invoice-details-form">
                <div className="upload-invoice-card-header">
                    <i className="bi bi-file-earmark-arrow-up" />
                    <h6>INVOICE DETAILS</h6>
                </div>

                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    {/* Asset TAG */}
                    <div className="upload-invoice-form-group">
                        <label className="upload-invoice-form-label">Asset TAG</label>
                        <input
                            type="text"
                            value={tag || ''}
                            readOnly
                            className="upload-invoice-input"
                        />
                    </div>

                    {/* Invoice Description */}
                    <div className="upload-invoice-form-group">
                        <label className="upload-invoice-form-label">
                            Invoice Description <span className="upload-invoice-required">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter invoice description..."
                            value={imgDesc}
                            onChange={(e) => setImgDesc(e.target.value)}
                            className={`upload-invoice-input ${ErrImgDesc ? 'error' : ''}`}
                        />
                        {ErrImgDesc && (
                            <span className="upload-invoice-error-message">
                                <i className="bi bi-exclamation-circle" /> {ErrImgDesc}
                            </span>
                        )}
                    </div>

                    {/* Upload Section */}
                    <div className="upload-invoice-upload-section">
                        <div className="upload-invoice-upload-header">
                            <i className="bi bi-cloud-upload" />
                            <div>
                                <h6 className="upload-invoice-upload-title">Upload Invoices</h6>
                                <p className="upload-invoice-upload-info">
                                    <i className="bi bi-info-circle" />
                                    Remaining attachments: <strong>{remainingFiles}</strong> | Max 5MB per file
                                </p>
                            </div>
                        </div>

                        <div className="upload-invoice-form-grid upload-invoice-form-grid-2col">
                            <div className="upload-invoice-form-group">
                                <label className="upload-invoice-form-label">
                                    Document Type <span className="upload-invoice-required">*</span>
                                </label>
                                <select
                                    onChange={handleNoDoc}
                                    value={NoOfDoc}
                                    className={`upload-invoice-select ${ErrNoOfDoc ? 'error' : ''}`}
                                >
                                    <option value="">Select document type...</option>
                                    {DocTypeList.filter(option => option.doc_type === "First").length === 0 && (
                                        <option value="First">Document First</option>)}
                                    {DocTypeList.filter(option => option.doc_type === "Second").length === 0 && (
                                        <option value="Second">Document Second</option>)}
                                    {DocTypeList.filter(option => option.doc_type === "Third").length === 0 && (
                                        <option value="Third">Document Third</option>)}
                                    {DocTypeList.filter(option => option.doc_type === "Fourth").length === 0 && (
                                        <option value="Fourth">Document Fourth</option>)}
                                    {DocTypeList.filter(option => option.doc_type === "Fifth").length === 0 && (
                                        <option value="Fifth">Document Fifth</option>)}
                                </select>
                                {ErrNoOfDoc && (
                                    <span className="upload-invoice-error-message">
                                        <i className="bi bi-exclamation-circle" /> {ErrNoOfDoc}
                                    </span>
                                )}
                            </div>

                            <div className="upload-invoice-form-group">
                                <label className="upload-invoice-form-label">
                                    Choose Files <span className="upload-invoice-required">*</span>
                                </label>
                                <input
                                    type="file"
                                    onChange={handleUploadInvoice}
                                    multiple
                                    className={`upload-invoice-file-input ${ErrUploadAssetInvoice ? 'error' : ''}`}
                                />
                                {ErrUploadAssetInvoice && (
                                    <span className="upload-invoice-error-message">
                                        <i className="bi bi-exclamation-circle" /> {ErrUploadAssetInvoice}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="upload-invoice-actions">
                        {(Tag !== '' && Tag !== null) ? (
                            <>
                                <button type="submit" className="upload-invoice-btn upload-invoice-btn-primary upload-invoice-btn-lg">
                                    <i className="bi bi-check-circle" /> Update
                                </button>
                                <a href={'/asset-details?tag=' + Tag}>
                                    <button type="button" className="upload-invoice-btn upload-invoice-btn-secondary upload-invoice-btn-lg">
                                        <i className="bi bi-x-circle" /> Cancel
                                    </button>
                                </a>
                            </>
                        ) : (<button
                            type="submit"
                            disabled={disabled}
                            className="al-btn al-btn-primary al-btn-lg"
                        ><i className="bi bi-upload" /> UPLOAD INVOICE</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}
